var map = {
	"./payments/Piastrix.svg": [
		4256,
		4256
	],
	"./payments/RussiaP2PTransferByAbroadCard.svg": [
		83582,
		83582
	],
	"./payments/RussiaP2PTransferByAbroadPhone.svg": [
		77089,
		77089
	],
	"./payments/RussiaP2PTransferByCard.svg": [
		7361,
		7361
	],
	"./payments/RussiaP2PTransferByPhone.svg": [
		9977,
		9977
	],
	"./payments/RussiaP2PTransferBySber.svg": [
		11359,
		11359
	],
	"./payments/RussiaP2PTransferByTbank.svg": [
		14810,
		14810
	],
	"./payments/aiforytinkoff.svg": [
		21023,
		21023
	],
	"./payments/apay.svg": [
		21636,
		21636
	],
	"./payments/astropaycard.svg": [
		61644,
		61644
	],
	"./payments/codi.svg": [
		70393,
		70393
	],
	"./payments/ecopayz.svg": [
		35728,
		35728
	],
	"./payments/jetonindia.svg": [
		11324,
		11324
	],
	"./payments/marscrypto.svg": [
		42757,
		42757
	],
	"./payments/marscrypto_eth.svg": [
		58911,
		58911
	],
	"./payments/marscryptopay.svg": [
		789,
		789
	],
	"./payments/monetixoxxo.svg": [
		31890,
		31890
	],
	"./payments/monetixpix.svg": [
		73744,
		73744
	],
	"./payments/neteller.svg": [
		4959,
		4959
	],
	"./payments/perfectmoney.svg": [
		16758,
		92811
	],
	"./payments/piastrixwebmoney.svg": [
		80105,
		80105
	],
	"./payments/skrill.svg": [
		96705,
		96705
	],
	"./payments/spei.svg": [
		50510,
		50510
	],
	"./payments/stp.svg": [
		60160,
		60160
	],
	"./providers/18+.svg": [
		99735,
		99735
	],
	"./providers/amatic.svg": [
		67572,
		67572
	],
	"./providers/amusnet.svg": [
		71340,
		71340
	],
	"./providers/betsoft.svg": [
		31241,
		31241
	],
	"./providers/evolution.svg": [
		37749,
		37749
	],
	"./providers/evoplay.svg": [
		75632,
		75632
	],
	"./providers/ezugi.svg": [
		21254,
		21254
	],
	"./providers/microgaming.svg": [
		38033,
		38033
	],
	"./providers/netent.svg": [
		9945,
		86881
	],
	"./providers/onetouch.svg": [
		83888,
		83888
	],
	"./providers/playngo.svg": [
		51137,
		51137
	],
	"./providers/pragmaticplay.svg": [
		21559,
		21559
	],
	"./providers/quickspin.svg": [
		73102,
		73102
	],
	"./providers/spinomenal.svg": [
		77056,
		62154
	],
	"./providers/yggdrasil.svg": [
		40314,
		28582
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 30197;
module.exports = webpackAsyncContext;